export interface ServiceOptionsPropConfigSchema {
  baseURL: string | '';
  cartURL: string | '';
  storyBlokURL: string | '';
}
export class ServiceOptionsPropConfig {
  private static instance: ServiceOptionsPropConfig;

  config: ServiceOptionsPropConfigSchema = {
    baseURL: '',
    cartURL: '',
    storyBlokURL: ''
  };

  private constructor(p_config: ServiceOptionsPropConfigSchema) {
    this.config = p_config;
  }
  getConfig = () => {
    return this.config;
  };

  getBaseUrl = () => {
    return this.config?.baseURL ?? '';
  };

  getCartUrl = () => {
    return this.config?.cartURL ?? '';
  };

  getSBUrl = () => {
    return this.config?.storyBlokURL ?? '';
  };

  public static getInstance = (): ServiceOptionsPropConfig => {
    return ServiceOptionsPropConfig.instance;
  };
  public static create = (p_config: ServiceOptionsPropConfigSchema): void => {
    ServiceOptionsPropConfig.instance = new ServiceOptionsPropConfig(p_config);
  };
}
